import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { RootState } from 'store';

import { ModalPayload, ModalStateProps } from './modal.types';

/**
 * Initial modal slice state for modal-related flags.
 */
const initialState: ModalStateProps = {
  attCancellation: null,
  attRemoveBenefit: null,
  paymentPastDue: null,
  programPaywall: {
    ctx: null,
    programCategory: null,
    show: false
  },
  renewalPopupStatus: null,
  renewalRequestPopup: null,
  resumeToProgram: null
};

const modalSlice = createSlice({
  initialState,
  name: 'modals',
  reducers: {
    clearPopups: () => initialState,
    closeModal: (state, action: PayloadAction<keyof ModalStateProps>) => {
      if (action.payload === 'programPaywall') {
        state.programPaywall = initialState.programPaywall;
        return;
      }

      if (action.payload === 'renewalPopupStatus') {
        state.renewalPopupStatus = initialState.renewalPopupStatus;
        return;
      }

      if (action.payload === 'renewalRequestPopup') {
        state.renewalRequestPopup = initialState.renewalRequestPopup;
        return;
      }

      if (action.payload === 'resumeToProgram') {
        state.resumeToProgram = initialState.resumeToProgram;
      }
      if (action.payload === 'paymentPastDue') {
        state.paymentPastDue = initialState.paymentPastDue;
      }
      if (action.payload === 'attCancellation') {
        state.attCancellation = initialState.attCancellation;
      }
      if (action.payload === 'attRemoveBenefit') {
        state.attRemoveBenefit = initialState.attRemoveBenefit;
      }
    },
    setModal: (state, action: PayloadAction<ModalPayload>) => {
      const { key, value } = action.payload;

      if (key === 'programPaywall') {
        state.programPaywall = value;
        return;
      }

      if (key === 'renewalPopupStatus') {
        state.renewalPopupStatus = value;
        return;
      }

      if (key === 'renewalRequestPopup') {
        state.renewalRequestPopup = value;
        return;
      }

      if (key === 'resumeToProgram') {
        state.resumeToProgram = value;
      }
      if (key === 'paymentPastDue') {
        state.paymentPastDue = value;
      }
      if (key === 'attCancellation') {
        state.attCancellation = value;
      }
      if (key === 'attRemoveBenefit') {
        state.attRemoveBenefit = value;
      }
    }
  }
});

export const { closeModal, setModal } = modalSlice.actions;

export const selectModalState = (state: RootState) => state.modals;

export default modalSlice.reducer;
